"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.cellDisabledStyle = exports.cellPaddingStyle = void 0;
const widgets_1 = require("@tableau/widgets");
exports.cellPaddingStyle = {
    paddingLeft: widgets_1.TabStyles.Spacing.MediumSpace,
    paddingRight: widgets_1.TabStyles.Spacing.MediumSpace,
    height: '100%', // so empty columns select row in connect-to grids
};
exports.cellDisabledStyle = {
    opacity: 0.6,
};
//# sourceMappingURL=CellStyles.js.map